import { appendError, getMap, getStoreMarker, setStoresDistance } from "../components/coverageAreaUtil";
import { MAP_MARKER_COLOR, MAP_AUTH_FAILED_CLASS } from "../utilities/constants";
import { getNewStoreData } from "../checkout/shippingCT";
import { checkCoverageArea, updateShipmentAddress, showCoverageAreaErrorModal } from "./shippingCTUtils";
import {
    setFilledStatus,
    handlePostalCodeInputRules,
    appendPostalOnFocus
} from "../utilities/globalUtilities";
import SimpleBar from "simplebar";
const googleMap = require("../components/googleMap");
const regex = require("../utilities/regex");
const debounce = require("lodash/debounce");

const $cache = {
    document: $(document),
    shippingNewStoreModal: $("#shipping-new-store-modal"),
    shippingConfirmCoverageModal: $("#shipping-confirm-coverage-area-modal")
};

let customerCoordinates = {};
let searchCoordinates = {};

/**
 * @function
 * @description - Retrieves postal code of customer current position
 */
const getPostalReverse = () => {
    $cache.document.on("click", ".js-postal-code-get-coordinates", () => {
        const $postalCodeInput = $cache.shippingNewStoreModal.find("#coverage-postal-code");

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(position => {
                customerCoordinates.latitude = position.coords.latitude;
                customerCoordinates.longitude = position.coords.longitude;

                let google = window.google;
                let geocoder = new google.maps.Geocoder();
                let latlng = { lat: parseFloat(customerCoordinates.latitude), lng: parseFloat(customerCoordinates.longitude) };

                if ($(`.${MAP_AUTH_FAILED_CLASS}`).length) {
                    appendError(".js-coverage-area-error", "data-error-auth-failed");
                    return;
                }

                geocoder.geocode({ location: latlng }, (results, status) => {
                    if (status === "OK") {
                        if (results.length > 0) {
                            let postalDetected = false;
                            for (let i = 0; i < results.length; i++) {
                                let result = results[i];

                                if (result.types.indexOf("postal_code") !== -1) {
                                    let postalCode = result.address_components[0].long_name;
                                    if (postalCode && postalCode.length == 4 && regex.values.digits.test(postalCode)) {
                                        postalCode = postalCode.padEnd(8, "-000");
                                    }

                                    postalDetected = true;
                                    $postalCodeInput.val(postalCode).addClass("filled");
                                    document.querySelectorAll("#shipping-coverage-area-modal .postal-code-coordinates-btn").forEach(btn => btn.classList.add("d-none"));
                                    document.querySelectorAll("#shipping-coverage-area-modal .postal-code-btn").forEach(btn => btn.classList.remove("d-none"));
                                    break;
                                }
                            }
                            if (!postalDetected) {
                                appendError(".js-coverage-area-error", "data-error-general");
                            }
                        } else {
                            appendError(".js-coverage-area-error", "data-error-nostores");
                        }
                    } else {
                        appendError(".js-coverage-area-error", "data-error-general");
                    }
                });
            }, () => appendError(".js-coverage-area-error", "data-error-allowgeo"));
        } else {
            appendError(".js-coverage-area-error", "data-error-apigeo");
        }
    });
};

/**
 * @function
 * @description - toggles visibility of buttons inside zip code input on Click&Go coverage area modal.
 * Shows delete/confirm buttons if there's text; otherwise, shows geolocation icon.
 */
const showSetStoreContextButton = () => {
    const deleteInputButton = document.querySelector("#shipping-new-store-modal .postal-code-btn");
    const setStoreContextButton = document.querySelector("#shipping-new-store-modal .postal-code-coordinates-btn");

    const handleClassChange = (mutationList) => {
        mutationList.forEach(mutation => {
            if (mutation.type === "attributes" && mutation.attributeName === "class") {
                if (mutation.target.classList.contains("d-none")) {
                    setStoreContextButton.classList.remove("d-none");
                } else {
                    setStoreContextButton.classList.add("d-none");
                }
            }
        });
    };

    const observer = new MutationObserver(handleClassChange);

    observer.observe(deleteInputButton, { attributes: true });
};

/**
 * @function
 * @description Calculates distance to stores once google map script loaded.
 */
const googlemapInitialized = () => {
    $cache.document.on("googlemap:initialized", () => {
        if ($cache.shippingNewStoreModal.find(".search-coordinates").length) {
            setStoresDistance($cache.shippingNewStoreModal);
        }
    });
};

/**
 * @function
 * @description - Asks for geolocation permission before rendering map
 */
const showStoreDetails = () => {
    navigator.geolocation.getCurrentPosition(onPositionAllow, onPositionDecline);
};

/**
 * @function
 * @description - Shows google map for selected store with customer position
 */
const onPositionAllow = position => {
    customerCoordinates.latitude = position.coords.latitude;
    customerCoordinates.longitude = position.coords.longitude;

    showStoresMap();
};

/**
 * @function
 * @description - Shows google map for selected store without customer position
 */
const onPositionDecline = () => {
    customerCoordinates.latitude = null;
    customerCoordinates.longitude = null;

    showStoresMap();
};

/**
 * @private
 * @function
 * @description - Returns marker of customer current position
 * @param {Object} map - Map object
 */
const getCustomerMarker = map => {
    let google = window.google;
    let customerPosition = {lat: Number(customerCoordinates.latitude), lng: Number(customerCoordinates.longitude)};
    let customerLocation = new google.maps.Marker({
        icon: {
            path: google.maps.SymbolPath.CIRCLE,
            strokeColor: MAP_MARKER_COLOR,
            strokeWeight: 1,
            scale: 5
        },
        clickable: false,
        position: customerPosition,
        map: map,
        optimized: false
    });

    return customerLocation;
};

/**
 * @private
 * @function
 * @description - Starts the stores map
 */
const showStoresMap = () => {
    let storeMarker;
    let customerMarker;
    let google = window.google;
    let map = getMap("map-stores");
    let bounds = new google.maps.LatLngBounds();
    const $storesMainWrapper = $cache.shippingNewStoreModal.find(".js-stores-main-wrapper");
    const stores = $cache.shippingNewStoreModal.find(".delivery-nearest .js-store-details");
    const $coverageModalBody = $cache.shippingNewStoreModal.find(".coverage-modal-body");

    $storesMainWrapper.removeClass("d-none");
    $coverageModalBody.addClass("coverage-modal-map");

    stores.each(function () {
        const storeWrapper = $(this);

        if (storeWrapper.data("delivery-latitude") != null && storeWrapper.data("delivery-longitude") != null) {
            storeMarker = getStoreMarker(storeWrapper, map);
            bounds.extend(storeMarker.position);
        }
    });

    // prepare customer current location
    if (customerCoordinates.latitude && customerCoordinates.longitude) {
        customerMarker = getCustomerMarker(map);
        bounds.extend(customerMarker.position);
    }

    map.fitBounds(bounds);
    $cache.shippingNewStoreModal.find(".modal-dialog").addClass("coverage-area-modal");
};

/**
 * @function
 * @description Handles change event for Store inputs
 */
const setStoreContext = () => {
    const $deliveryNearest = $cache.shippingNewStoreModal.find(".delivery-nearest");
    const previousCheckedStoreOnMap = $deliveryNearest.find(".pwc-form-check-input:checked").first();

    $(".js-new-store").on("click", function () {
        let targetParams = getNewStoreData();
        let activeStep = $(".js-step-active.step-type--address").length > 1 ? $(".js-shipment-step.slick-active").find(".js-step-active.step-type--address") : $(".js-step-active");
        let isPrimaryShipment = activeStep?.attr("data-is-primary") == "true" ? true : false;

        let callbackResult;
        checkCoverageArea(targetParams, result => {
            callbackResult = result;
        });

        if (callbackResult.error) {
            showCoverageAreaErrorModal(true, previousCheckedStoreOnMap);

            return;
        }

        targetParams.customerStatus = callbackResult.data.customerStatus;

        if (!isPrimaryShipment) {
            updateShipmentAddress(targetParams, activeStep, true);
        } else {
            $cache.shippingConfirmCoverageModal.find(".modal-body").data("triggered-by", "new-store");
            $cache.shippingConfirmCoverageModal.modal("show");
        }
        // Hide current modal
        $cache.shippingNewStoreModal.modal("hide");
    });
};

/**
 * @function
 * @description - Loads next chunk of stores
 */
const storesScrollInit = () => {
    const $deliveryNearest = $cache.shippingNewStoreModal.find(".delivery-nearest");

    if ($deliveryNearest.length > 0) {
        const simpleBar = new SimpleBar(document.querySelector("#shipping-new-store-modal .delivery-nearest"));

        if (simpleBar.getScrollElement()) {
            simpleBar.getScrollElement().addEventListener("scroll", debounce(function () {
                const $this = $(this);

                if ($this.scrollTop() + $this.innerHeight() >= $this[0].scrollHeight && $this.find(".coverage-area-no-stores-chunk").length === 0) {
                    const storesPerLoadNext = Math.floor($deliveryNearest.attr("data-stores-per-load-next"));

                    const params = {
                        latitude: searchCoordinates.latitude,
                        longitude: searchCoordinates.longitude,
                        storesPerLoadNext: storesPerLoadNext
                    };

                    $.ajax({
                        url: $deliveryNearest.data("url"),
                        type: "GET",
                        data: params,
                        success: response => {
                            const storesPerLoadFuture = storesPerLoadNext + Math.floor($deliveryNearest.attr("data-stores-per-load"));

                            $deliveryNearest.find(".simplebar-content").append(response);
                            $deliveryNearest.attr("data-stores-per-load-next", storesPerLoadFuture);
                            setFilledStatus();
                            handlePostalCodeInputRules();
                            appendPostalOnFocus($("#coverage-postal-code"));
                            setStoreContext();
                            if ($cache.shippingNewStoreModal?.find(".search-coordinates").length) {
                                setStoresDistance($cache.shippingNewStoreModal);
                            }
                        }
                    });
                }
            }, 100));
        }
    }
};

/**
 * @function
 * @description - Tries to find a nearby store using the provided postal code
 */
const findStoreByPostalCode = () => {
    $cache.shippingNewStoreModal.off("submit", ".coverage-area-form").on("submit", ".coverage-area-form", e => {
        e.preventDefault();

        $cache.shippingNewStoreModal.find("#coverage-postal-code").trigger("blur");

        let $this = $(e.currentTarget);
        let deliveryLocation = $this.find(".postal-code").val();
        if (deliveryLocation && deliveryLocation.length == 4 && regex.values.digits.test(deliveryLocation)) {
            deliveryLocation = deliveryLocation.padEnd(8, "-000");
            $this.find(".postal-code").val(deliveryLocation);
        }
        let google = window.google;

        if (!deliveryLocation || (regex.values.digits.test(deliveryLocation) && !regex.values.coverageAreaPostalCode.test(deliveryLocation))) {
            appendError(".js-coverage-area-error", "data-error-postalcode");
            return;
        }

        const url = $(e.target).attr("action");

        if ($(`.${MAP_AUTH_FAILED_CLASS}`).length) {
            appendError(".js-coverage-area-error", "data-error-auth-failed");
            return;
        }

        let geocoder = new google.maps.Geocoder();
        geocoder.geocode({"address": deliveryLocation, "componentRestrictions": {"country": "PT"}}, (results, status) => {
            if (status == google.maps.GeocoderStatus.OK) {
                if (results[0].geometry.location.lat() && results[0].geometry.location.lng()) {
                    let deliveryPostalCode = "";
                    let result = results[0];
                    for (let i = 0; i < result.address_components.length; i++) {
                        let addressComponent = result.address_components[i];

                        if (addressComponent.types.indexOf("postal_code") !== -1 && addressComponent.long_name) {
                            deliveryPostalCode = addressComponent.long_name;
                            break;
                        }
                    }

                    searchCoordinates.latitude = results[0].geometry.location.lat();
                    searchCoordinates.longitude = results[0].geometry.location.lng();

                    const params = {
                        deliveryLocation: deliveryLocation,
                        deliveryPostalCode: deliveryPostalCode,
                        latitude: results[0].geometry.location.lat(),
                        longitude: results[0].geometry.location.lng(),
                        searchLatitude: results[0].geometry.location.lat(),
                        searchLongitude: results[0].geometry.location.lng()
                    };

                    $.ajax({
                        url: url,
                        type: "GET",
                        data: params,
                        success: response => {
                            const $deliveryArea = $cache.shippingNewStoreModal.find(".delivery-area");

                            $deliveryArea.html(response);

                            setStoreContext();
                            storesScrollInit();

                            //calculate and add distances
                            setStoresDistance($cache.shippingNewStoreModal);

                            // reinit events
                            showStoreDetails();
                        }
                    });
                }
            } else if (status == google.maps.GeocoderStatus.ZERO_RESULTS) {
                appendError(".js-coverage-area-error", "data-error-nostores");
            } else {
                appendError(".js-coverage-area-error", "data-error-general");
            }
        });
    });
};

/**
 * @function
 * @description - Init Shipping New Store events
 */
const shippingNewStoreEvents = () => {
    getPostalReverse();
    showSetStoreContextButton();
    googleMap.mapInit();
    googlemapInitialized();
    showStoreDetails();
    setStoreContext();
    storesScrollInit();
    findStoreByPostalCode();
};

export { shippingNewStoreEvents };
